import { Controller } from "@hotwired/stimulus"

const DURATION = 1400

// Connects to data-controller="count-up"
// Counts each number target up from zero once, when the group scrolls into view.
// The server renders the final figure, so the text is right without JS, under
// reduced motion, and after the count ends (the original text is restored).
export default class extends Controller {
  static targets = ["number"]

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.observer.disconnect()
        this.numberTargets.forEach((target) => this.count(target))
      }
    }, { threshold: 0.35 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  count(target) {
    const finalText = target.textContent
    const to = parseFloat(target.dataset.countUpTo)
    const decimals = (target.dataset.countUpTo.split(".")[1] || "").length
    const suffix = target.dataset.countUpSuffix || ""
    const format = new Intl.NumberFormat(document.documentElement.lang, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
      useGrouping: "always"
    })
    const start = performance.now()

    const step = (now) => {
      const progress = Math.min((now - start) / DURATION, 1)
      if (progress < 1) {
        target.textContent = `${format.format(to * (1 - Math.pow(1 - progress, 4)))}${suffix}`
        requestAnimationFrame(step)
      } else {
        target.textContent = finalText
      }
    }
    requestAnimationFrame(step)
  }
}
